const transactionHistoryTypes = {
  FETCH_TRANSACTIONS_HISTORY_START: 'FETCH_TRANSACTIONS_HISTORY_START',
  FETCH_TRANSACTIONS_HISTORY_SUCCESS: 'FETCH_TRANSACTIONS_HISTORY_SUCCESS',
  FETCH_TRANSACTIONS_HISTORY_FAILURE: 'FETCH_TRANSACTIONS_HISTORY_FAILURE',

  QUERY_TRANSACTION_START: 'QUERY_TRANSACTION_START',
  QUERY_TRANSACTION_SUCCESS: 'QUERY_TRANSACTION_SUCCESS',
  QUERY_TRANSACTION_FAILURE: 'QUERY_TRANSACTION_FAILURE',

  QUERY_MULTIPLE_TRANSACTIONS_START: 'QUERY_MULTIPLE_TRANSACTIONS_START',
  QUERY_MULTIPLE_TRANSACTIONS_SUCCESS: 'QUERY_MULTIPLE_TRANSACTIONS_SUCCESS',
  QUERY_MULTIPLE_TRANSACTIONS_FAILURE: 'QUERY_MULTIPLE_TRANSACTIONS_FAILURE',

  EXPORT_TRANSACTION_START: 'EXPORT_TRANSACTION_START',
  EXPORT_TRANSACTION_SUCCESS: 'EXPORT_TRANSACTION_SUCCESS',
  EXPORT_TRANSACTION_FAILURE: 'EXPORT_TRANSACTION_FAILURE',
};

export default transactionHistoryTypes;
